import React, { useEffect, useState } from "react";
import "./partners.scss";
import logo from "../../images/logo.svg";

import partnerLogo1 from "../../images/partner-1.png";
import partnerLogo2 from "../../images/partner-2.png";
import partnerLogo3 from "../../images/partner-3.png";
import partnerLogo4 from "../../images/partner-4.png";
import partnerLogo5 from "../../images/partner-5.png";
import partnerLogo6 from "../../images/partner-6.png";
import partnerLogo7 from "../../images/partner-7.png";
import partnerLogo8 from "../../images/partner-8.png";
import partnerLogo9 from "../../images/partner-9.png";
import partnerLogo10 from "../../images/partner-10.png";

const Partners = (data) => {
  return (
    <>
      <div className="partners-cont">
          <h2>Our Growth Partners</h2>
          <p>Collaborating with us to make lending smarter, faster, and more accessible.</p>
          <div className="partners-logos">
              <div className="part-logo">
                <img src={partnerLogo9} alt="" />
              </div>
              <div className="part-logo">
                <img src={partnerLogo2} alt="" />
              </div>
              <div className="part-logo">
                <img src={partnerLogo3} alt="" />
              </div>
              <div className="part-logo">
                <img src={partnerLogo4} alt="" />
              </div>
              <div className="part-logo">
                <img src={partnerLogo5} alt="" />
              </div>
              <div className="part-logo">
                <img src={partnerLogo6} alt="" />
              </div>
              <div className="part-logo">
                <img src={partnerLogo7} alt="" />
              </div>
              <div className="part-logo">
                <img src={partnerLogo8} alt="" />
              </div>
              <div className="part-logo">
                <img src={partnerLogo1} alt="" />
              </div>
              <div className="part-logo">
                <img src={partnerLogo10} alt="" />
              </div>
          </div>
      </div>
    </>
  );
};


export default Partners;
